<template>
  <div
    id="Modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">รหัสคลังสินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">ชื่อคลังสินค้า:</label>
                      <input class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label">ผู้จำหน่าย (Supplier):</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">ประเภทสินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">ชื่อสินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">รหัส SAP:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">รหัส NFC:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label">รหัสบาร์โค้ด:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">รหัสทรัพย์สิน (เบิยร์สด):</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">รหัสทรัพย์สิน (บัญชี):</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label">แบรนด์สินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">วันที่รับเข้า:</label>
                      <input type="date" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">วันที่ผลิต:</label>
                      <input type="date" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">จำนวนวันที่รับประกัน:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">วันที่สิ้นสุดการรับประกัน:</label>
                      <input type="date" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">จำนวนวันที่อยู่ในคลังสินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">มูลค่าสินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-6">
                    <div class="form-group">
                      <label class="label">อายุสินค้า:</label>
                      <input type="text" class="form-control" value />
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label">รูปภาพ:</label>
                      <input type="file" class="form-control" value />
                    </div>
                  </div>

                  <!--
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>สถานะ:</label>
                      <select id="statusStock" class="form-control m-select2" style="width: 100%;">
                        <option value>-</option>
                        <option value="open">เปิด</option>
                        <option value="close">ปิด</option>
                      </select>
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="la la-save"></i> บันทึกข้อมูล
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
export default {
  async mounted() {
    let self = this;
    let router = this.$router;

    $("#Modal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        //self.$parent.reloadDataTable(false);
      })
      .modal("show");

    /*
    $("#statusStock").select2({
      placeholder: "-",
      allowClear: true
    });
    */
  }
};
</script>


// WEBPACK FOOTER //
// App/Components/Master/Product/CreateProduct.vue